const BLOG_POST_CONCAT_ID_BASE = '/blog-post/';

const globalUrls = {
    LANDING_PAGE: '/', //Acerca de nosotras
    ABOUT_US: '/acerca-de', //Acerca de nosotras
    ADMIN_LOGIN: '/admin',
    CLIENT_LOGIN: '/login', //Login de Miembros
    CLIENT_REGISTER: '/registrarme', //Registrar nuevo usuario
    CLIENT_FORGOT_PASSWORD: '/olvide-pass',
    CLIENT_CHANGE_PASSWORD: '/cambiar-pass',
    CLIENT_HOME: '/cuenta',
    CLIENT_HOME_PROFILE: '/cuenta-perfil',
    CLIENT_HOME_ADDRESSES: '/cuenta-direcciones',
    CLIENT_HOME_ORDERS: '/cuenta-ordenes',
    ADMIN_HOME: '/admin-home',
    ORDER_TRANSPORTATION: '/transporte',
    PACKER: '/empacar',
    ONLINE_STORE: '/tienda',//Tienda Web
    ONLINE_STORE_SELECT_DISTRITO: '/tienda-ubicacion',
    ONLINE_STORE_CHECKOUT: '/checkout-tienda',
    ONLINE_STORE_CHECKOUT_ANON: '/checkout-tienda-anon',
    SPECIAL_EVENTS: '/eventos',//Eventos
    BLOG: '/blog', //Blog
    BLOG_POST_CONCAT_ID: `${BLOG_POST_CONCAT_ID_BASE}`, //Blog post
    BLOG_POST: `${BLOG_POST_CONCAT_ID_BASE}:postId`, //Blog post
    PRIVACY_POLICY: '/politica-de-privacidad',
    APPOINTMENTS: '/citas',
    ACCOUNT_APPOINTMENTS: '/cuenta-citas',
    SERVICES_PUBLIC: '/servicios',
    PUBLIC_CALENDAR: '/calendario',
    UNAUTHORIZED: '/no-autorizado',
    ERROR: '/error'
};

export default globalUrls;
